// Centralized API URL detection
// In Emergent deploys, backend and frontend share the same origin
// This auto-detects the correct API URL

import { Capacitor } from '@capacitor/core';

const envUrl = process.env.REACT_APP_BACKEND_URL;

// Production API used when running inside the native app (iOS/Android).
// Inside Capacitor the app is served from localhost, so hostname detection
// below would wrongly target http://localhost:8001. Override it here.
const NATIVE_API_URL = envUrl || 'https://api.micoach.tech';

function getApiUrl() {
  // 0. Native app (Capacitor): the WebView runs at capacitor://localhost or
  // http://localhost, so we cannot infer the backend from the hostname.
  if (Capacitor.isNativePlatform()) {
    return NATIVE_API_URL;
  }

  const currentHost = window.location.hostname;
  const currentOrigin = window.location.origin;

  // 1. Emergent preview environment - use env URL
  if (currentHost.includes('preview.emergentagent.com')) {
    return envUrl || currentOrigin;
  }
  
  // 2. Emergent production deploy (*.emergent.host)
  if (currentHost.includes('emergent.host')) {
    return currentOrigin;
  }
  
  // 3. Custom domains (*.micoach.tech)
  // Frontend is deployed on Vercel while the API lives on Railway, so these
  // domains must prefer the configured backend URL instead of same-origin.
  if (currentHost.includes('micoach.tech')) {
    return envUrl || currentOrigin;
  }
  
  // 4. Localhost development
  if (currentHost === 'localhost' || currentHost === '127.0.0.1') {
    return envUrl || 'http://localhost:8001';
  }
  
  // 5. If env URL matches current host, use it
  if (envUrl) {
    try {
      const envHost = new URL(envUrl).hostname;
      if (envHost === currentHost) {
        return envUrl;
      }
    } catch {}
  }
  
  // Fallback: use current origin (assumes backend is co-located)
  return currentOrigin;
}

export const API_URL = getApiUrl();

// Solo en desarrollo. En producción no tiene sentido dejar la URL de la API en
// la consola del navegador de cada usuario.
if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
  console.log('[MiCoach API]', API_URL, '| Host:', window.location.hostname);
}

export default API_URL;
